import React from "react";
import { Label } from "../ui/label";
import { SearchableSelect } from "../ui/searchable-select";
import type { SearchableSelectOption } from "../ui/searchable-select";

interface LocationCodeFieldsProps {
  state: string;
  locationCode: string;
  oldLocationCode: string;
  onLocationCodeChange: (value: string) => void;
  onOldLocationCodeChange: (value: string) => void;
  newLocationCodeOptions: SearchableSelectOption[];
  oldLocationCodeOptions: SearchableSelectOption[];
  loadingSites?: boolean;
  locationCodeOpen?: boolean;
  onLocationCodeOpenChange?: (open: boolean) => void;
  oldLocationCodeOpen?: boolean;
  onOldLocationCodeOpenChange?: (open: boolean) => void;
  errors?: { locationCode?: string; oldLocationCode?: string };
}

export function LocationCodeFields({
  state,
  locationCode,
  oldLocationCode,
  onLocationCodeChange,
  onOldLocationCodeChange,
  newLocationCodeOptions,
  oldLocationCodeOptions,
  loadingSites = false,
  locationCodeOpen,
  onLocationCodeOpenChange,
  oldLocationCodeOpen,
  onOldLocationCodeOpenChange,
  errors,
}: LocationCodeFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <Label className="text-gray-700 font-semibold mb-2 block">New Location Code *</Label>
        <SearchableSelect
          value={locationCode}
          onValueChange={onLocationCodeChange}
          options={newLocationCodeOptions}
          open={locationCodeOpen}
          onOpenChange={onLocationCodeOpenChange}
          disabled={!state || loadingSites}
          placeholder={loadingSites ? "Loading..." : "Select"}
          searchPlaceholder="Search new location code..."
          emptyMessage={!state ? "Select state first" : "No location codes available"}
          noResultsMessage="No options found"
        />
        {!state && (
          <p className="text-gray-500 text-sm mt-1">Please select a state first</p>
        )}
        {errors?.locationCode && (
          <p className="text-red-500 text-sm mt-1">{errors.locationCode}</p>
        )}
      </div>

      <div>
        <Label className="text-gray-700 font-semibold mb-2 block">Old Location Code *</Label>
        <SearchableSelect
          value={oldLocationCode}
          onValueChange={onOldLocationCodeChange}
          options={oldLocationCodeOptions}
          open={oldLocationCodeOpen}
          onOpenChange={onOldLocationCodeOpenChange}
          disabled={!state || loadingSites}
          placeholder={loadingSites ? "Loading..." : "Select"}
          searchPlaceholder="Search old location code..."
          emptyMessage={!state ? "Select state first" : "No location codes available"}
          noResultsMessage="No options found"
        />
        {!state && (
          <p className="text-gray-500 text-sm mt-1">Please select a state first</p>
        )}
        {errors?.oldLocationCode && (
          <p className="text-red-500 text-sm mt-1">{errors.oldLocationCode}</p>
        )}
      </div>
    </div>
  );
}
